import { ComponentDataSourceService } from '../component-data-source.service';
import { LoadDataParams } from '../../../interfaces/DataSource/DataSourceParams.interface';
import { of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { DUNA_TEMPLATES_EVENT } from './templates-admin-events';

const visibilityLabels: Record<string, string> = {
  private: 'Privat',
  shared: 'Delt',
  public: 'Offentlig'
};

function dispatchTemplateAction(action: string, row: unknown): void {
  window.dispatchEvent(
    new CustomEvent(DUNA_TEMPLATES_EVENT, {
      detail: { action, row }
    })
  );
}

export const templates = (service: ComponentDataSourceService, params?: LoadDataParams) => {
  return {
    name: 'Skabeloner',
    description: 'Liste over event-skabeloner',
    execute: (params?: LoadDataParams) => {
      return service['loadDataWithStandardFiltersGET']('templates', '/duna_templates', params).pipe(
        catchError((error) => {
          console.error('Error fetching templates:', error);
          return of({ items: [], totalCount: 0 });
        }),
        map((result) => {
          if (result && result.items) {
            return {
              items: result.items,
              totalCount: result.totalCount,
              pageSize: result.pageSize,
              pageIndex: result.pageIndex,
              filters: result.filters
            };
          }
          return { items: [], totalCount: 0 };
        })
      );
    },
    settings: {
      columns: [
        { key: 'name', header: 'Navn', type: 'text', sortable: true },
        { key: 'description', header: 'Beskrivelse', type: 'text', sortable: false },
        {
          key: 'visibility',
          header: 'Synlighed',
          type: 'text',
          sortable: true,
          transform: (value: string) => visibilityLabels[value] || value
        },
        { key: 'created_at', header: 'Oprettet', type: 'date', sortable: true },
        {
          key: 'create_events',
          header: '',
          type: 'button',
          buttonText: 'Opret events',
          buttonColor: 'primary',
          variant: 'flat',
          alignment: 'right',
          width: '140px',
          action: (row: unknown) => dispatchTemplateAction('copy', row)
        },
        {
          key: 'actions',
          header: '',
          type: 'menu',
          sortable: false,
          width: '48px',
          menuItems: [
            {
              label: 'Rediger',
              icon: 'edit',
              action: (row: unknown) => dispatchTemplateAction('edit', row)
            },
            {
              label: 'Slet',
              icon: 'delete',
              color: '#d32f2f',
              action: (row: unknown) => dispatchTemplateAction('confirm-delete', row)
            }
          ]
        }
      ],
      pageable: true,
      sortable: true,
      filterable: true,
      searchable: true
    }
  };
};
